import React from "react";

export const scrollContext = React.createContext({
        topScroll(): void {throw new Error("No definido");
    }
});

export function useScroll() {
    return React.useContext(scrollContext);
}